<template>
  <a-form ref='form' :model='search' :style="{'marginBottom':'25px'}" :initialValues="search" :onFinish='pageSearchChange' layout='inline'>
    <a-form-item label="关键词" name='product_name'>
      <a-input v-model:value="search.product_name" :style="{width:'300px'}" placeholder="请输入关键词进行搜索" />
    </a-form-item>
    <a-form-item>
      <a-button type="primary" htmlType='submit'>搜索</a-button>
    </a-form-item>
  </a-form>
  <a-table :pagination='false' :loading='listLoading' bordered :columns='columns' :data-source='list'>
       <template v-slot:info="{record}">
      <a-card-meta>
        <template #avatar>
          <img :src="info.picdomain+'/'+(record.product_image||record.cover_image_url)" alt=""
            style="width:50px;height: 50px;object-fit:cover">
        </template>
        <template #description>{{record.product_name}}</template>
      </a-card-meta>
    </template>
    <template v-slot:category="{ record }">
      <p v-if='record.category_name'>{{record.category_name || '未分类'}}</p>
      <p v-else>{{record.category.name || '未分类'}}</p>
    </template>
    <template v-slot:action="{ record }">
      <a-button type="primary"  v-has:delProductAssociation="()=>{delProduct(record)}" >删除</a-button>
    </template>
  </a-table>
  <a-pagination :style="{marginTop:'20px',textAlign:'right'}" show-size-changer show-quick-jumper :current="search.page" :page-size="search.limit" :total="total" @change="pageCurrentChange" @showSizeChange="pageSizeChange" :show-total="total => `总数: ${total} `" />
</template>

<script>
import useTableSearch from "@/hooks/useTableSearch";
import { onMounted } from '@vue/runtime-core';
import {getProduct} from '@/api/product'
import store from '@/store'
import {un_bind_product} from '@/api/qrcodeActivitys.js'
import { Modal } from 'ant-design-vue';
import { iscode } from '../../../../utils/app';
const defSearch={product_name:"",limit:10,page:1,trace_template_uuid:""}
const columns=[
          {
            title: "ID",
            dataIndex: "id",
            key: "id",
          },

          {
            title: "商品信息",
            dataIndex: "info",
            key: "info",
            slots: { customRender: "info" },
          },
          {
            title: "产品库分类",
            dataIndex: "category",
            key: "category",
            slots: { customRender: "category" },
          },
          {
            title: "价格/元",
            dataIndex: "product_price",
            key: "product_price",
          },
          {
            title: "操作",
            key: "action",
            width: 120,
            slots: { customRender: "action" },
          },
        ]
export default {
  props:{
    currentData:Object
  },
  setup(props,{emit}) {
    const {
      pageCurrentChange,
      pageSizeChange,
      search,
      list,
      initData,
      total,
      pageSearchChange,
      listLoading,
    } = useTableSearch({ data: defSearch });
    const tableHoosks = {
      pageCurrentChange,
      pageSizeChange,
      search,
      initData,
      list,
      total,
      pageSearchChange,
      listLoading,
    };
    onMounted(()=>{
      if(props.currentData){
          search.value.trace_template_uuid=props.currentData.template_uuid
      }
      tableHoosks.initData(getProduct,search.value)
    })
    // 取消绑定
    const delProduct=(data)=>{
           Modal.confirm({
        centered: true,
        content: "确定要取消该商品关联模板？",
        onOk: async () => {
          let res = await un_bind_product({product_id:data.id}).then((res) => res.data);
          if (iscode(res, true)) {
            tableHoosks.initData(getProduct,search.value)
            emit('update')
          }
        },
      });
    }
    return{
        ...tableHoosks,
        columns,
        info:store.state.user.info,
        delProduct
    }
  },
};
</script>